import type { NavigateFunction } from 'react-router-dom';

export const navigateBackOrTo = (
  navigate: NavigateFunction,
  fallbackPath: string,
  options: { preferFallback?: boolean } = {},
) => {
  const historyIndex = window.history.state?.idx;

  if (
    !options.preferFallback &&
    typeof historyIndex === 'number' &&
    historyIndex > 0
  ) {
    navigate(-1);
    return;
  }

  navigate(fallbackPath, { replace: true });
};
